import gql from 'graphql-tag';

const RESET_PASSWORD = gql`
  mutation resetPassword($password: String!) {
    changePassword(password: $password)
  }
`;

export {RESET_PASSWORD};
